import type { HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, of, switchMap } from 'rxjs';
import { map } from 'rxjs/operators';

import { AssistantConfigHttp } from './assistant-config.http';
import { AssistantConfigActions } from './assistant-config.state';

export const loadAssistantConfig = createEffect(
  (actions$ = inject(Actions), http = inject(AssistantConfigHttp)) =>
    actions$.pipe(
      ofType(AssistantConfigActions.fetch),
      switchMap(() =>
        http.fetch().pipe(
          map(payload => AssistantConfigActions.fetchSuccess({ payload })),
          catchError((error: HttpErrorResponse) =>
            of(AssistantConfigActions.fetchFailed({ payload: error })),
          ),
        ),
      ),
    ),
  { functional: true },
);
